import { Navigate } from "react-router-dom";
import { URLS } from "../../utils/constants";

const getFallbackPathForRoles = (roles = []) => {
  if (roles.includes("ADMIN")) return URLS.ADMIN;
  if (roles.includes("USER")) return URLS.USERS;
  if (roles.includes("TRAINER")) return URLS.TRAINERS_DASHBOARD;
  return URLS.HOME;
};

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const auth = localStorage.getItem("token");
  if (!auth) return <Navigate to={URLS.HOME} replace />;

  if (!allowedRoles.length) return children;

  let roles = [];
  try {
    roles = JSON.parse(localStorage.getItem("roles") || "[]");
  } catch {
    roles = [];
  }

  const hasAccess = allowedRoles.some((role) => roles.includes(role));
  return hasAccess ? children : <Navigate to={getFallbackPathForRoles(roles)} replace />;
};

export default ProtectedRoute;
